import { compose, lifecycle, withHandlers } from 'recompose';

import { Notification as NTFC } from './Notification';

const enhance = compose(
  withHandlers({
    onClose: ({ id, onClose }) => () => onClose(id),
  }),
  lifecycle({
    componentDidMount() {
      const { onClose, delayInterval } = this.props;

      this.timer = setTimeout(onClose, delayInterval);
    },
    componentWillUnmount() {
      clearTimeout(this.timer);
    },
  }),
);

export const Notification = enhance(NTFC);
